/*
 * @Descripttion: 
 * @Author: zhanghang
 * @Date: 2023-04-07 10:47:57
 * @LastEditors: zhanghang
 * @LastEditTime: 2023-07-19 11:05:16
 */
export default {
  methods: {
    handleUpdateMap() { },

    //更新数据源
    handleUpdateDataUrl(url, map) {
      // 更新映射字段
      this.handleUpdateMap(map)
      let params = this.getConfigAttachRequestParams(this.dataSourceParams);
      url = "/dbsource/interface/" + url
      this.getInterfaceAPI(url, 'get', params);
      return this
    },
    //更新综合数据参数
    handleUpdateParams(key, value) {
      let $params = this.getConfigAttachRequestParams(this.combineTableParams);
      dsf.mix(true, $params, {
        [key]: value
      })
      this.dealCombineTableParams($params)
      return this
    },
    //更新数据源参数
    handleUpdateDataSourceParams(key, value) {
      let $params = this.getConfigAttachRequestParams(this.dataSourceParams);
      dsf.mix(true, $params, {
        [key]: value
      })
      this.dealDataSourceParams($params)
      return this
    },
    //获取查询参数
    handleParams() {
      let realParams = this.realParams
      let params = this.getConfigAttachRequestParams();
      return dsf.mix(true, params, realParams)
    },
    //获取数据源地址
    handleGetDataSource() {
      return this.dataURL
    },
  }
}